<!--
 * @Description: 页面首页
 * @Author: pliybird
 * @Date: 2022-01-30 00:14:48
 * @LastEditTime: 2024-05-30 19:43:06
 * @LastEditors: 程栋
 * @filePath: Do not edit
-->
<template>
  <Layout>
    <div class="home-slick-carousel rn-slick-arrow">
      <VueSlickCarousel
        arrows
        infinite
        :autoplay="slideList.length > 1"
        :touchMove="slideList.length > 1"
        :autoplaySpeed="5000"
        class="home-img-h"
      >
        <!-- <div v-for="(item, index) in slideList" :key="index"
                    class="slider-area slider-style-6 shape-right inheader-not-transparent bg_image bg_image_fixed"
                    :style="{ 'background-image': `url(${item.imageUrl})` }">
                </div> -->
        <img
          v-for="(item, index) in slideList"
          :key="index"
          :src="item.imageUrl"
          alt=""
        />
      </VueSlickCarousel>
      <div class="home-slick-carousel-video">
        <div class="container">
          <div class="row row--30 align-items-center justify-content-end">
            <div class="col-lg-6 order-1 order-lg-2">
              <div class="video-wrap pr_sm--0 pl_sm--0">
                <Video
                  v-if="$i18n.locale === 'zh_CN'"
                  :video-data="videoData"
                  :videoStyle="2"
                  column="col-12"
                />
                <img
                  v-else
                  :src="require('@/assets/images/aboutUs/company_image.png')"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Separator/> -->
    <div
      class="rwt-counterup-area relative mt-dec--80 mt_sm--0"
      style="z-index: 2"
    >
      <div class="container">
        <Counter
          :counter-style="5"
          text-align="center"
          column="col-lg-3 col-md-6 col-sm-6 col-12"
        />
      </div>
    </div>
    <div class="rwt-tab-area rn-section-gap">
      <div class="container home-tab">
        <div class="row mb--40">
          <div class="col-lg-12">
            <SectionTitle
              text-align="center"
              :title="$t('home.product_service.title')"
              :sectionTitleStyle="1"
              data-aos="fade-up"
              data-aos-delay="60"
            />
          </div>
        </div>
        <home-product-tab />
      </div>
    </div>
    <div class="rwt-split-area rn-section-gap case">
      <!-- <img class="case-bg" src="../assets/images/home/case-bg.png" /> -->
      <div class="wrapper">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
              :title="$t('home.solution.title')"
              :sectionTitleStyle="1"
              textAlign="center"
              data-aos="fade-up"
              data-aos-delay="60"
            />
            <div class="container home-tab">
              <home-solution-tab />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 白皮书 -->
    <section
      v-if="$i18n.locale === 'zh_CN' && whitePaperList.length > 0"
      class="rn-section-gap paper-content"
    >
      <SectionTitle
        title="白皮书下载"
        :sectionTitleStyle="1"
        textAlign="center"
      />
      <div class="home-slick-carousel rn-slick-arrow container">
        <VueSlickCarousel
          arrows
          infinite
          swipeToSlide
          :slidesToShow="number"
          :slidesToScroll="1"
          :initialSlide="-0.2"
          :touchMove="
            isSmallScreen
              ? whitePaperList.length > 1
              : whitePaperList.length > 2
          "
        >
          <div
            v-for="item in whitePaperList"
            :key="item.id"
            class="col-11 col-lg-6 col-md-6 pr--20 paper-card"
          >
            <div class="d-flex p-3 p-md-5 p-lg-5 paper-card-item">
              <div class="col-11 d-blok d-sm-none">
                <h5 class="title text-ellipsis">{{ item.title }}</h5>
              </div>
              <div class="d-flex col-11">
                <div class="col-6 col-lg-6 col-md-6 display_dir_col">
                  <div class="list-wrap">
                    <div class="d-none d-sm-block">
                      <h5 class="title text-ellipsis" :title="item.title">
                        {{ item.title }}
                      </h5>
                    </div>
                    <p class="text-ellipsis description">{{ item.desc }}</p>
                  </div>
                  <div
                    class="vyung-button paper-left-btn d-none d-sm-block"
                    data-bs-toggle="modal"
                    data-bs-target="#whitePaperModal"
                    @click="handleSendCode(item.id, item.title)"
                  >
                    立即下载
                  </div>
                </div>
                <div
                  class="col-5 col-lg-5 col-md-5 offset-1 display_align_center"
                >
                  <img :src="item.imageUrl" alt="" />
                </div>
              </div>
              <div
                class="col-11 vyung-button paper-left-btn d-blok d-sm-none"
                data-bs-toggle="modal"
                data-bs-target="#whitePaperModal"
                @click="handleSendCode(item.id, item.title)"
              >
                立即下载
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    <!-- 白皮书 -->
    <WhitePaper />

    <!-- 品牌案例 -->
    <section class="rn-section-gap" :class="{ en: $i18n.locale === 'en_US' }">
      <!-- <div>{{}}</div> -->
      <div class="container">
        <SectionTitle
          :title="$t('home.brand_case.title')"
          :sectionTitleStyle="1"
          textAlign="center"
        />
        <Brand :brandList="brandList" :brandStyle="1" />
        <div class="d-flex mt--30 justify-content-center align-items-center">
          <router-link
            :to="{ name: 'cases', params: { lang: $i18n.locale } }"
            class="vyung-button"
            >{{ $t("home.more") }}</router-link
          >
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from "../components/common/Layout";
import VueSlickCarousel from "vue-slick-carousel";
import Icon from "../components/icon/Icon";
import Video from "../components/elements/video/Video";
import Separator from "../components/elements/separator/Separator";
import SectionTitle from "../components/elements/sectionTitle/SectionTitle";
import Brand from "../components/elements/brand/Brand";
import Counter from "../components/elements/counterUp/Counter";
import HomeProductTab from "./components/HomeProductTab";
import HomeSolutionTab from "./components/HomeSolutionTab";
import { slideShowList, casesList, paperList } from "@/helpers/api";
// import VyungScroll from '@/components/elements/scroll/scroll'
import WhitePaper from "./WhitePaper";

export default {
  name: "Home",
  components: {
    Icon,
    VueSlickCarousel,
    Layout,
    Separator,
    SectionTitle,
    Video,
    Brand,
    Counter,
    HomeProductTab,
    HomeSolutionTab,
    WhitePaper,
  },
  computed: {
    // brandList(){
    //     let _arr = []
    //     for (let index = 1; index <= 20; index++) {
    //         _arr.push(
    //             {
    //                 image:require(`@/assets/images/brand/brand-${index}.png`)
    //             }
    //         )
    //     }
    //     return _arr
    // },
  },
  data() {
    return {
      slideList: [
        {
          id: 0,
          imageUrl: require(`@/assets/images/banner/home_banner.png`),
        },
      ],
      videoData: [
        {
          src:
            process.env.VUE_APP_VIDEO_URL +
            "/$web/video/intro.mp4?" +
            process.env.VUE_APP_VIDEO_RAXWDL,
          thumb:
            process.env.VUE_APP_VIDEO_URL +
            "/$web/video/thumb/intro_thumb.jpeg?" +
            process.env.VUE_APP_VIDEO_RAXWDL,
        },
      ],
      brandList: [],
      whitePaperList: [],
      innerWidth: window.innerWidth,
      number: null,
      isSmallScreen: false, // 标识：小屏幕
      obj: null,
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      if (to.name === from.name) {
        this.getSlideShowList();
      }
    },
    innerWidth(val) {
      this.setNumber();
    },
  },
  created() {
    this.getSlideShowList();
    this.getCaseList();
    this.getPaperList();
  },
  mounted() {
    this.setNumber();
    window.addEventListener("resize", this.setNumber);
  },
  methods: {
    // 设置白皮书显示几个item
    setNumber() {
      this.innerWidth = window.innerWidth;
      this.number = this.innerWidth < 900 ? 1.2 : 2.2;
      this.isSmallScreen = this.innerWidth < 900;
    },
    callbacks(obj) {
      this.obj = obj;
    },
    // 轮播图
    getSlideShowList() {
      const { slideList } = this;
      slideShowList(`lang=${this.$i18n.locale}`).then((res) => {
        this.slideList = res?.data ?? slideList;
      });
    },
    // 品牌案例
    getCaseList() {
      casesList(`PageIndex=1&PageSize=20`).then((res) => {
        this.brandList = res.data.rows;
      });
    },
    // 白皮书
    getPaperList() {
      const { whitePaperList } = this;
      paperList(`lang=${this.$i18n.locale}`).then((res) => {
        this.whitePaperList = res?.data ?? whitePaperList;
      });
    },
    // 白皮书：下载
    handleSendCode(id, title) {
      const obj = {
        id: id,
        title: title,
      };
      const myModalEl = document.getElementById("whitePaperModal_ID");
      myModalEl.value = JSON.stringify(obj);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setNumber);
  },
};
</script>